import type { GetUserGroupsWithApproversResponseRow } from '@risksmart-app/drizzle/src/dto';
import type { GetUserGroupsWithApproversQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetUserGroupsWithApproversDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createQueryHook, REFERENCE_DATA_STALE_TIME_MS } from 'src/utils';

export const useGetUserGroupsWithApprovers = createQueryHook<
  Record<string, never>,
  GetUserGroupsWithApproversResponseRow[],
  GetUserGroupsWithApproversQuery
>({
  trpcQueryOptions: (trpc) =>
    trpc.frontend.userGroup.userGroupsWithApprovers.queryOptions(),
  mapTrpcDataToGraphQL: (data) => ({ user_group: data }),
  // Org reference data; writes invalidate it. See COI-882.
  trpcStaleTime: REFERENCE_DATA_STALE_TIME_MS,
  graphqlDocument: GetUserGroupsWithApproversDocument,
});
